import React from 'react';
import { ComparisonTable, type ComparisonRow } from './ComparisonTable';
const rows: ComparisonRow[] = [{
  left: '40 open tabs, three checklists, one half-finished spreadsheet',
  right: 'One volume open. The month you’re living. Nothing else.'
}, {
  left: '“Are we behind?” — every single week',
  right: 'The month is closed, so you’re not behind. By definition.'
}, {
  left: '$500 here, $500 there, and a number that keeps growing',
  right: 'Every line accounted for before you sign anything'
}, {
  left: 'Vendor quotes you can’t compare and questions you don’t know to ask',
  right: 'One sheet per vendor: what to ask, what’s included, what’s a red flag'
}, {
  left: 'Sunday nights spent planning instead of living',
  right: 'Twenty minutes, three tasks, done — the rest of the week is yours'
}, {
  left: 'The couple who spent twelve months feeling behind',
  right: 'The couple who actually enjoyed being engaged'
}];
export function Transformation() {
  return <section aria-labelledby="transformation-heading" className="w-full bg-white" data-id="element-214" data-mp="1c7l8m4ajtmyw">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-215" data-mp="1765oqfk3xmi3">
        <h2 id="transformation-heading" className="font-serif font-normal text-ink text-[28px] sm:text-[38px] leading-tight text-center" data-id="element-216" data-mp="134tutxu7af43">
          From &ldquo;I think we&apos;re behind&rdquo; to &ldquo;we&apos;re
          exactly where we should be&rdquo;
        </h2>
        <div className="mx-auto mt-6 h-px w-32 bg-sage/40" aria-hidden="true" data-id="element-217" data-mp="1quegwplnhshl" />

        <div className="mt-12" data-id="element-218" data-mp="1m47sapr527zc">
          <ComparisonTable headers={['Right now', 'With the plan']} rows={rows} caption="Before and after the plan" data-id="element-219" data-mp="1m3en3t7tvqjb" />
        </div>
      </div>
    </section>;
}